import { PeopleMerchantDto } from './people-merchant.dto';
import { PeopleQueryBaseDto } from './people-query-base.dto';

export class PeopleBrandDto {
  id?: number;
  name?: string;
  merchantGroupId?: number;
  photoURL?: string;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;

  merchants?: PeopleMerchantDto[];
}

export interface PeopleBrandQueryDto extends PeopleQueryBaseDto {
    name?: string;
}
